import { useContext, useEffect } from "react";
import SRMAuthContext from "../../store/saleRepresentativesManagementStore/saleRepresentativesManagement-auth-context";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import useHttpFetch from "../../hooks/useHttpFetch";
import LoadingOverLoadedPage from "../../Components/UI/LoadingOverLoadedPage/LoadingOverLoadedPage";
import { Helmet } from "react-helmet-async";

const IsLoggedInInSRM = () => {
  const { clientAuthInfo, setClientAuthInfo } = useContext(SRMAuthContext);
  const navigate = useNavigate();
  const { sendRequest } = useHttpFetch(false, "SaleRepresentativesManagement");
  const location = useLocation();

  useEffect(() => {
    const getAuthOnLoad = async () => {
      const verifyReqOptions = {
        url: `PackageAccess`,
        noMiddleUrl: true,
      };

      const authRes = await sendRequest(verifyReqOptions);
      if (authRes?.resIsOk) {
        setClientAuthInfo((ps) => ({
          ...ps,
          isLoggedIn: true,
          cellphone: authRes?.response?.cellphone?.replace("+98", "0"),
        }));
        navigate(
          `/user-information/${
            location?.pathname?.includes("333status") ? "333status" : "add"
          }/${authRes?.response?.cellphone?.replace("+98", "0")}`
        );
      } else {
        navigate("/sale-representatives-management/login");
      }

      setClientAuthInfo((ps) => ({
        ...ps,
        isLoading: false,
      }));
    };
    getAuthOnLoad();
  }, []);

  return (
    <>
      <Helmet>
        <meta name="description" content="SaleRepresentativesManagement Information" />
        <meta property="og:title" content="Pergas Teb - SaleRepresentativesManagement" />
        <meta property="og:description" content="SaleRepresentativesManagement Information" />
        <meta name="twitter:title" content="Pergas Teb - SaleRepresentativesManagement" />
        <meta name="twitter:description" content="SaleRepresentativesManagement Information" />
        <title>Pergas Teb - SaleRepresentativesManagement</title>
      </Helmet>
      {clientAuthInfo.isLoading ? <LoadingOverLoadedPage /> : <Outlet />}
    </>
  );
};

export default IsLoggedInInSRM;
